import * as React from 'react';
import Assets from '@lib/Assets'
import Button from '../common/Button';
import Modal from '@lib/components/common/Modal'
import RowRenderer from '../index-table/IndexTableRowRenderer'
import IndexPageContext from './IndexPageContext';
import _ from 'lodash';

export default class IndexTableRow extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            deleteModalIsOpen: false,
            isCheckboxChecked: false,
            row: props.row
        }

        this.transformedRow = {}
        for (let [k, v] of Object.entries(props.row)) {
            this.transformedRow[k.toLowerCase()] = v
        }
    }

    onCheckboxChanged = e => {
        if (this.props.onCheckboxChanged) {
            this.props.onCheckboxChanged(this.props.row.id)
        }
    }

    onReloadCall() {
        if (this.props.onReloadCall !== undefined)
            this.props.onReloadCall();
    }

    renderCheckbox() {
        if (this.props.hasRowCheckbox !== true) {
            return <React.Fragment/>
        }

        if (this.props.row.canDelete === false) {
            return (
                <td className="table-checkbox-column">

                </td>
            )
        }

        return (
            <td className="table-checkbox-column">
                <input id={this.createCheckboxId()} type="checkbox" onChange={this.onCheckboxChanged}
                       checked={this.props.isChecked}/>
                <label htmlFor={this.createCheckboxId()}></label>
            </td>
        )
    }

    createCheckboxId() {
        return this.props.row.id;
    }


    renderDataCell(column, value) {
        if (column.uiHint) {
            return this.rowRenderer['render' + column.uiHint](column, value);
        }

        if (typeof this.rowRenderer['render' + column.slug + 'Column'] === 'function') {
            return this.rowRenderer['render' + column.slug + 'Column'](column, value)
        }

        if (typeof this['render' + column.slug + 'Column'] === 'function') {
            return this['render' + column.slug + 'Column'](column, value);
        }

        return (
            <td key={column.slug}>{value === null ? '-' : value}</td>
        )
    }

    onDeleteClick = (editAPIService) => {
        editAPIService.delete(this.props.row.id).then(() => {
            this.setState({
                deleteModalIsOpen: false
            });

            if (this.props.onRemoveRowClick) {
                this.props.onRemoveRowClick(this.props.row.id)
            }
        })
    }

    onCopyClick = (button, editAPIService) => {
        editAPIService.copy(this.props.row.id)
    }

    renderDeleteButtonAction = (button, index) => {
        return (
            <IndexPageContext.Consumer key={index}>
                {({editAPIService}) => (
                    <React.Fragment>
                        <a className="index-action-button" onClick={() => this.setState({deleteModalIsOpen: true})}><img
                            src={Assets[button.icon]}/></a>
                        <Modal isOpen={this.state.deleteModalIsOpen}
                               onClose={() => this.setState({deleteModalIsOpen: false})}>
                            <Modal.Header>{__('Remove')}</Modal.Header>
                            <Modal.Body>{__('Do you want to remove this object?')}</Modal.Body>
                            <Modal.Footer>
                                <Button theme={Button.Theme.BorderOnly}
                                        onClick={() => this.setState({deleteModalIsOpen: false})}>{__('Cancel')}</Button>
                                <Button theme={Button.Theme.BorderOnly}
                                        onClick={() => this.onDeleteClick(editAPIService)}>{__('Remove')}</Button>
                            </Modal.Footer>
                        </Modal>
                    </React.Fragment>
                )}
            </IndexPageContext.Consumer>
        )
    }

    actionButtonClick = (button, editAPIService) => {
        var action = this[`on${button.slug}Click`]
        if (typeof (action) == 'function') {
            action(button, editAPIService)
            return
        }

        window.location.href = this.rowRenderer.getUrl(button)
    }

    renderBaseActionButtons() {
        var actionButtons = this.props.actionButtons.filter(x => x.slug != 'Edit');
        if (actionButtons.length === 0 && !this.props.forceRenderActionButtonsColumn) {
            return <React.Fragment></React.Fragment>;
        }

        if (typeof this.rowRenderer["renderActionButtons"] === "function") {
            return this.rowRenderer.renderActionButtons(this.props.row);
        }

        return (
            <IndexPageContext.Consumer>
                {({editAPIService}) => (
                    <td className="table-actions-column">
                        <div className="index-action-buttons">
                            {actionButtons.map((button) => {
                                var rendererAction = this.rowRenderer[`render${button.slug}ButtonAction`];
                                if (typeof (rendererAction) === "function") {
                                    return this.rowRenderer[`render${button.slug}ButtonAction`](button, this.props.row, editAPIService, button.slug);
                                }
                                var action = this[`render${button.slug}ButtonAction`]
                                if (typeof (action) == 'function') {
                                    return action(button, button.slug, editAPIService)
                                }
                                return (
                                    <a key={button.slug} className="index-action-button"
                                       onClick={() => this.actionButtonClick(button, editAPIService)}>
                                        <img src={Assets[button.icon]}/>
                                    </a>
                                )
                            })}
                        </div>
                    </td>
                )}
            </IndexPageContext.Consumer>
        )
    }

    loadRowRenderer() {
        this.rowRenderer = new RowRenderer(this.props, this);
    }

    render() {
        if (this.rowRenderer === null || typeof this.rowRenderer === 'undefined') {
            this.loadRowRenderer();
        } else {
            this.rowRenderer.setProps(this.props);
        }

        if (typeof this.rowRenderer.renderIndexTableRow === 'function') {
            return (
                <React.Fragment>
                    {this.rowRenderer.renderIndexTableRow()}
                    {this.renderSpacer()}
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                    {this.renderIndexTableRow()}
                    {this.renderSpacer()}
                </React.Fragment>
            )
        }
    }


    renderSpacer = () => {
        return (
            <tr className="index-table-spacer">
                <td></td>

                {this.props.columns.map((x, idx) => (
                    <td key={idx}></td>
                ))}

                <td></td>
            </tr>
        )
    }

    getRowAttributes() {
        return {}
    }

    renderIndexTableRow() {
        return (
            <tr {...this.getRowAttributes()}>
                {this.renderCheckbox()}
                {this.props.columns.map((column, idx) => {
                        return <React.Fragment key={idx}>
                            {this.renderDataCell(column, this.findValueByColumnSlug(column.slug))}
                        </React.Fragment>
                    }
                )}
                {this.renderBaseActionButtons()}
            </tr>
        )
    }

    findValueByColumnSlug(slug) {
        return this.props.row[_.lowerFirst(slug)]
    }

    renderUpdateActionAtValueColumn(column, value) {
        return (
            <td>
                <div>{this.props.row.updateActionAt}</div>
                <div>{this.props.row.updateActionUserName}</div>
            </td>
        );
    }
}
